export default function () {
  setTimeout(() => {
    document.documentElement.classList.remove('wf-loading')
  }, 2000)
}